import { Plugin } from '@ckeditor/ckeditor5-core';
import VideoUploadUI from "./videoupload/videouploadui";
import VideoUploadEditing from "./videoupload/videouploadediting";
import VideoUploadProgress from "./videoupload/videouploadprogress";
export default class VideoUpload extends Plugin {
    /**
     * @inheritDoc
     */
    static get pluginName() {
        return 'VideoUpload';
    }
    /**
     * @inheritDoc
     */
    static get requires() {
        return [VideoUploadEditing, VideoUploadUI, VideoUploadProgress];
    }
}
//# sourceMappingURL=videoupload.js.map